import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Router ve store'u global olarak erişilebilir yap (axios interceptor için)
window.router = router
window.store = store
// Uygulama başlarken logout bayrağını duruma göre ayarla
try {
  const token = localStorage.getItem('token')
  const user = localStorage.getItem('user')
  window.isLoggedOut = !(token && user)
} catch (e) {
  window.isLoggedOut = true
}
 
createApp(App)
  .use(store)
  .use(router)
  .mount('#app') 